module.exports = __webpack_public_path__ + "img/user.50ddf894.svg";